<div id="bdc-admin-search">
  <div class="center">

    <!-- CONTENT HEADER -->
    <div class="header" fxLayout="row" fxLayoutAlign="start center">

      <div class="search-wrapper" fxFlex fxLayout="row" fxLayoutAlign="start center">

        <div class="search" fxLayout="row" fxLayoutAlign="start center">
          <mat-icon class="secondary-text">search</mat-icon>
          <input [matAutocomplete]="autoPage" type="text" matInput name="searchText" id="SearchBox"
                 placeholder="Je cherche ..." matTooltip="Recherche d'une page"
                 [formControl]="term" fxFlex>

          <mat-autocomplete #autoPage="matAutocomplete" [displayWith]="displayPageFn.bind(this)">
            <mat-option *ngFor="let model of pageSearch | async"
                        matTooltip="cliquer pour éditer la page"
                        [value]="model"
                        (onSelectionChange)="goPage(model)">
              {{ model.title }}
            </mat-option>
          </mat-autocomplete>

        </div>

      </div>

    </div>
  </div>
</div>
